<template>
  <div id="EmergencyServices">
    <div class="no-side-bar">
      <nav v-if="$store.state.user.authenticated">
        <TopNav></TopNav>
        <MobileNav></MobileNav>
      </nav>
      <div class="text-container">
        <h3 class="page-title">Emergency Service Contacts</h3>
        <p class="page-paragraph">If you feel like you’re a risk to yourself or others right now please contact emergency services in your local area via the list below:</p>
      </div>
      <main class="content-wrap">
        <div role="document" class="content-card w-100">
          <div class="content-inner" v-html="decodeData(content)"></div>
        </div>
      </main>
      <footer v-if="$store.state.user.authenticated">
        <Footer></Footer>
      </footer>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from "axios";
import config from "../config/constants";
import TopNav from "../components/TopNav.vue";
import MobileNav from "../components/MobileNav.vue";
import Footer from "../components/Footer";
export default {
  name: "EmergencyServices",
  components: {
    Footer,
    TopNav,
    MobileNav,
  },
  data() {
    return {
      content: "",
      isLoading: true,
    };
  },
  mounted() {
    this.getEmergencyServices();
  },
  methods: {
    decodeData(data) {
      try {
        return Buffer.from(data, "base64");
      } catch (error) {
        return data;
      }
    },
    async getEmergencyServices() {
      const payload = {
        slug: "emergency_services",
      };
      let res = await axios.post(
        config.api_env + "/application/api/u/info/get-info",
        payload,
        config.options
      );
      if (res.data.success) {
        this.content = res.data.dynamic_string?.string;
        this.isLoading = false;
      } else if (res.data.err && res.data.err.includes("3994")) {
        this.$store.dispatch("logout");
        this.$router.push("/login").catch((err) => { });
      }
    },
  },
};
</script>
<style lang="less">
body {
  padding: 0 !important;
}

#EmergencyServices {
  padding: 40px 0;
  overflow: scroll;
  background-color: #fff;

  .content-wrap {
    padding: 0 20px;
    width: max-content;
    margin: 0 auto 32px;
  }

  .text-container {
    padding: 0 20px;
    max-width: 500px;
    margin: auto;
  }

  .page-title {
    text-align: left;
    font-size: 2.2rem;
    font-family: 'DMSans Bold', sans-serif;
    color: #1E1E22;
    margin-bottom: 32px;
  }

  .page-paragraph {
    font-family: 'DMSans', sans-serif;
    font-size: 1.6rem;
    color: #1E1E22;
    margin-bottom: 32px;
  }

  .content-inner {
    max-width: 780px;
    font-size: 1.2rem;
    padding: 24px 42px;
    margin: 0 auto;
    box-shadow: 0px 4px 25px 0px #00000040;

    a {
      text-decoration: underline;
    }

    .region {
      font-family: "DMSans Bold", sans-serif;
    }

    td {
      padding: 16px;
    }

    th {
      padding-left: 16px;
      min-width: 140px;
    }
  }

  footer {
    padding: 0 20px;
  }
}
</style>
